import { Pipe, PipeTransform } from '@angular/core'

import dayjs from 'dayjs/esm'

@Pipe({
  name: 'dateDiff',
  standalone: true,
})
export class DateDiffPipe implements PipeTransform {
  transform(date1: string, date2: string): string {
    const diffInMinutes = dayjs(date1).diff(dayjs(date2), 'minute')
    const hours = Math.floor(diffInMinutes / 60)
    const minutes = diffInMinutes % 60
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
  }
}
